import { ValueFormatter } from '../../../common/format.js';
import { OneUxPlotChartTypographyToken, yTarget } from '../../types.js';
import { ValueScale } from './ValueScale.js';
import { getTextSize } from '../../../common/getTextSize.js';
const typography: OneUxPlotChartTypographyToken = 'label-100';
export const getTickPlacementInfo = (valueScale: ValueScale, yTarget: yTarget, valueFormatter: ValueFormatter, tick: number) => {
  const x = yTarget === 'left' ? valueScale.bounds.right - 2 : valueScale.bounds.left + 2;
  const y = Math.floor(valueScale.position(tick)) + 1.5;
  const textAnchor: 'end' | 'start' = yTarget === 'left' ? 'end' : 'start';
  const alignment: 'auto' | 'middle' | 'hanging' = 'middle';
  const text = valueFormatter.formatValue(tick);
  return {
    x,
    y,
    alignment,
    textAnchor,
    text,
    typography
  };
};
export const getTicksMaxWidth = (ticks: number[], valueFormatter: ValueFormatter) => {
  let tick = '';
  for (let i = ticks.length - 1; i >= 0; i--) {
    const nextTick = valueFormatter.formatValue(ticks[i]);
    tick = nextTick.length > tick.length ? nextTick : tick;
  }
  return getTextSize(tick, typography).width;
};